import apiConfig from '../../apiConfig';

export const getUSerGrouppScreenList = async (at, groupId) => {
	const response = await apiConfig.post(
		'/API/SYSTEM/USERS/GROUPS/GET_USERS_SCREENS_LIST',{
			User_Group_Id: groupId
		},
		{
			headers: {
				Authorization: `Bearer ${at}`,
			},
		}
	);

	if (response.data.Status) {
		for (let i in response.data.Data) {
			if (response.data.Data[i].Selected === 1) {
				response.data.Data[i].Selected = true;
			} else {
				response.data.Data[i].Selected = false;
			}
		}
		return response.data.Data;
	}

	return [];
};
